import { createAsyncThunk } from '@reduxjs/toolkit';

import { blogApi } from '~/api/blog/blog';
import { GetAuthorPostsParams, Post } from '~/api/blog/blogTypes';
import { authorBlogActions, authorBlogSliceName } from '~/atomic/page/author/blog/authorBlog.slice';
import { DEFAULT_PAGE_SIZE_FOR_BLOGS } from '~/feature/blogs/blog.slice';
import { paginationActions } from '~/feature/pagination/pagination.slice';
import { environments } from '~/lib/const';
import { RootState } from '~/store';

export const getAuthorPosts = createAsyncThunk<
Post[],
GetAuthorPostsParams,
{
  state: RootState
}>(
  `${authorBlogSliceName}/getAuthorPosts`,
  async (data, thunkAPI) => {
    const { page } = thunkAPI.getState().pagination;
    const { isGetAuthorPostsLoading } = thunkAPI.getState().authorBlog;

    if (!isGetAuthorPostsLoading) {
      try {
        thunkAPI.dispatch(authorBlogActions.setIsGetAuthorPostsLoading(true));
        const getAuthorPostsResult = await blogApi.getAuthorPosts({
          ...data,
          page,
          perPage: DEFAULT_PAGE_SIZE_FOR_BLOGS,
        });

        if ('data' in getAuthorPostsResult) {
          thunkAPI.dispatch(authorBlogActions.changeAuthorPosts(getAuthorPostsResult.data));
          thunkAPI.dispatch(paginationActions.setTotal({ total: getAuthorPostsResult.total }));
          thunkAPI.dispatch(paginationActions.setPage({ page: getAuthorPostsResult.currentPage }));
          thunkAPI.dispatch(
            paginationActions.setPageSize({ perPage: getAuthorPostsResult.perPage }),
          );
          return getAuthorPostsResult.data;
        }
      } catch (error) {
        if (environments.isClient && error instanceof Error) {
          const { message } = await import('~/atomic/atom/message');

          message.error(error.message);
        }
        return thunkAPI.rejectWithValue({ message: error.message });
      } finally {
        thunkAPI.dispatch(authorBlogActions.setIsGetAuthorPostsLoading(false));
      }
    }
  },
);
